import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlService} from './url.service';
import {RequestConfig} from '../../configs/request.config';
import {ResponseService} from './response.service';
import {Router} from '@angular/router';
import {StoreService} from './store.service';
import {PermissionService} from './permission.service';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {PermissionConfig} from "../../configs/permission.config";

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private _http: HttpClient,
              private _router: Router,
              private _storeService: StoreService,
              private _urlService: UrlService,
              private _permissionService: PermissionService,
              private _responseService: ResponseService) { }

  signUp(user: any) {
    return this._http.post(this._urlService.userSignUp(), user, RequestConfig.options)
      .pipe(map(res => {
        const error = this._responseService.parseError(res);
        if (error) throw new Error(error);

        this._router.navigate(['login']);
        return this._responseService.parseResponse(res);
      }),
        catchError(err => {
          console.log(err);
          this._responseService.parseUnhandledError(err);
          throw err;
        }),);
  }

  logIn(body: any) {
    return this._http.post(this._urlService.userLogin(), body, RequestConfig.options)
      .pipe(mergeMap(res => {
        const error = this._responseService.parseError(res);
        if (error) throw new Error(error);

        return this.isAuth()
      }));
  }

  logOut() {
    return this._http.get(this._urlService.logOut(), RequestConfig.options)
      .pipe(mergeMap(res => {
        const error = this._responseService.parseError(res);
        if (error) throw new Error(error);

        return this.isAuth();
      }));
  }

  restore(body: string) {
    return this._http.post(this._urlService.userPassRestore(), body, RequestConfig.options)
      .pipe(map(res => {
        const error = this._responseService.parseError(res);
        if (error) throw new Error(error);

        this._router.navigate(['login']);
        return this._responseService.parseResponse(res);
      }),
        catchError(err => {
          console.log(err);
          this._responseService.parseUnhandledError(err);
          throw err;
        }),);
  }

  isAuth() {
    return this._http.post(this._urlService.isAuth(), {}, RequestConfig.options)
      .pipe(map(res => {
        const error = this._responseService.parseError(res);
        if (error) throw new Error(error);

        const data: any = this._responseService.parseResponse(res);

        if (data) {
          if (data.admin) {
            this._permissionService.set(PermissionConfig.admin);
          }

          this._storeService.actions.initSidebar();
        } else {
          this._permissionService.clear()
        }

        this._storeService.mutations.setAuth(!!data);
        this._storeService.mutations.setModerator(data || null);

        return data;
      }),
        catchError(err => {
          console.log(err);
          this._responseService.parseUnhandledError(err);
          throw err;
        }),);
  }
}
